// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/profile.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { ProfileService } from "./profile_pb";

/**
 * ChangePassword replaces the caller's own password, after checking the
 * current one.
 *
 * @generated from rpc travplaces.v1.ProfileService.ChangePassword
 */
export const changePassword = ProfileService.method.changePassword;
